import makeStyles from "@mui/styles/makeStyles";

const useCaseTableRowStyles = makeStyles((theme) => ({
    tooltip: {
        overflowY: "scroll",
    },
    calculatedRenewalRow: {
        "& td": {
            fontStyle: "italic",
        },
    },
    calculatedRenewalIcon: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(0.5),
    },
}));

export default useCaseTableRowStyles;
